
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^(51(54|90)|1545|4896|7875|9807)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
